import { render, staticRenderFns } from "./vRecipeNutritionLabelPrintout.vue?vue&type=template&id=5daf58c8&scoped=true"
import script from "./vRecipeNutritionLabelPrintout.vue?vue&type=script&setup=true&lang=ts"
export * from "./vRecipeNutritionLabelPrintout.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./vRecipeNutritionLabelPrintout.vue?vue&type=style&index=0&id=5daf58c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5daf58c8",
  null
  
)

export default component.exports